import { createApp } from '@app/adapters/create-app'

import createStore from '@app/application/workflows/screens/workflow-review/store'
import extractEndpointParams from '@app/application/workflows/utils/extract-endpoint-params.ts'
import SfSidepaneContentSwitcher from '@app/shared/vue/components/layout/sf-sidepane-content-switcher.vue'

window.onDomLoad(function ($dom) {
  $dom
    .find("[data-behaviour='workflow-review-sidepane-mount']")
    .each(function () {
      const data = this.dataset

      const reviewItems = JSON.parse(data.reviewItems)
      const tagCloud = JSON.parse(data.tagCloud)

      const app = createApp(SfSidepaneContentSwitcher, {
        ledgerId: data.ledgerId,
        ledgerLabel: data.ledgerLabel,
        onWorkflowReview: true,
        shouldRenderAuditLog: data.shouldRenderAuditLog === 'true',
      })

      const endpointParams = extractEndpointParams({
        ledgerId: data.ledgerId,
        reviewItems,
      })

      app.use(
        createStore(endpointParams, {
          tagCloud,
        })
      )

      app.mount(this)
    })
})
